<template>
  <div class="store-visit">
    <NavHeaderBar :showSearch="false" :navBarTitle="$t('shared.filter.reOrderSellIn')">
    </NavHeaderBar>
    <div class="visit-form-content">
      <div class="form-item form-time-item">
        <div class="label required">
          <span class="alone-font">{{ $t('form.visitDate') }}</span>
        </div>
        <van-field
          readonly
          clickable
          name="datetimePicker"
          :disabled="true"
          :value="visitForm.visitTime"
          placeholder=""
          @click="handleCalendar"
          :border="false"
          class="custom-field"
        >
          <template #left-icon>
            <van-icon name="calendar-o" color="#b9cbed" />
          </template>
        </van-field>
        <van-popup v-model="showCalendar" position="bottom">
          <van-datetime-picker
            v-model="currentDate"
            type="date"
            :title="$t('form.chooseDate')"
            :max-date="maxDate"
            @confirm="onConfirmDate"
            @cancel="showCalendar = false"
          />
        </van-popup>
      </div>
      <div class="form-item uploader-customer">
        <div class="label required">
          <span class="alone-font">{{ $t('form.checkInPhoto') }}</span>
        </div>
        <van-uploader v-model="visitForm.imgMap.check" max-count="1" :after-read="(files, detail) => afterRead(files, detail, 'check')" />
      </div>
      <van-collapse v-model="activeNames">
        <van-collapse-item :title="$t('form.directSellIn')" name="1" v-if="visitForm.po && checkPer(['admin', 'app:reorder:direct'])">
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.directOrNot') }}</span>
            </div>
            <van-field class="custom-field custom-radio-field">
              <template #input>
                <van-radio-group v-model="visitForm.po.isDirect" direction="horizontal">
                  <van-radio v-for="(subItem, subIndex) in radioList" :key="subIndex" :name="subItem.value">{{ subItem.label }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
          <div v-if="visitForm.po.isDirect">
            <div class="sub-title">
              <div class="top-title">
                <img class="ell-icon" src="@/assets/images/ell_icon.png" alt="">
                <div style="color: #317bff;">{{ $t('form.quantitySoldPcs') }}</div>
              </div>
              <div class="total-right">{{ $t('form.total') }} <span class="pcs-num">{{ totalProductQuantity }}</span> {{ $t('form.pcs') }}</div>
            </div>
            <div class="form-item" v-for="(brandItem, brandIndex) in visitForm.po.productList" :key="brandIndex">
              <div class="label square">
                <span>{{ brandItem.projectName }}</span>
              </div>
              <div class="brand-item" v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex">
                <div class="product-status">
                  <XuSelect v-model="subItem.productId" :dataOptions="filteredOptions.productList(brandIndex, subItem.productId, brandItem.projectId)" :placeholder="$t('tips.pleaseSelectProduct')" :fieldNames="{label: 'productName', value: 'id'}" @input="(val) => handelSelect(val, subItem)" />
                  <img src="@/assets/images/event_del.png" alt="" class="del-img" @click="handleDel(brandItem, subIndex)">
                </div>
                <div class="product-listing is-Direct" v-if="subItem.specList && subItem.specList.length > 0">
                  <van-collapse v-model="subItem.activeNames">
                    <van-collapse-item title="" name="1">
                      <template #title>
                        <div class="collapse-title">
                          <div>{{ $t('form.orderSalesVolume') }}：<span class="pcs-num" v-if="subItem.specList">{{ subItem.specList.reduce((acc, curr) => acc + Number(curr.quantity), 0) }}</span> {{ $t('form.pcs') }}</div>
                        </div>
                      </template>
                      <div class="quantity-item" v-for="specItem in subItem.specList" :key="specItem.specId">
                        <div class="title van-ellipsis">{{ specItem.specName }}</div>
                        <div class="stepper-custom">
                          <div class="step-btn" @click="handleStep(-5, specItem, 'quantity')">-5</div>
                          <div class="step-btn" @click="handleStep(-1, specItem, 'quantity')">-</div>
                          <van-field class="step-value" v-model.number="specItem.quantity" type="digit" :border="false" />
                          <div class="step-btn" @click="handleStep(1, specItem, 'quantity')">+</div>
                          <div class="step-btn" @click="handleStep(5, specItem, 'quantity')">+5</div>
                        </div>
                      </div>
                    </van-collapse-item>
                  </van-collapse>
                </div>
              </div>
              <div class="add-more" @click="handleAdd('productList', brandItem)">+ {{ $t('button.addMoreProductForOrder') }}</div>
            </div>
            <div class="sub-title">
              <div class="top-title">
                <img class="ell-icon" src="@/assets/images/ell_custom_icon.png" alt="">
                <div class="left-desc" style="color: #808000;">{{ $t('form.quantityGivenAwayPcs') }}</div>
              </div>
              <div class="total-right">{{ $t('form.total') }} <span class="pcs-num" style="color: #808000;">{{ totalGiveProductQuantity }}</span> {{ $t('form.pcs') }}</div>
            </div>
            <div class="form-item" v-for="(brandItem, brandIndex) in visitForm.po.giveProductList" :key="brandIndex + '1'">
              <div class="label custom-label square">
                <span>{{ brandItem.projectName }}</span>
              </div>
              <div class="brand-item" v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex">
                <div class="product-status">
                  <XuSelect v-model="subItem.productId" :dataOptions="filteredOptions.giveProductList(brandIndex, subItem.productId, brandItem.projectId)" :placeholder="$t('tips.pleaseSelectProduct')" :fieldNames="{label: 'productName', value: 'id'}" @input="(val) => handelSelect(val, subItem)" />
                  <img src="@/assets/images/event_del.png" alt="" class="del-img" @click="handleDel(brandItem, subIndex)">
                </div>
                <div class="product-listing is-Direct" v-if="subItem.specList && subItem.specList.length > 0">
                  <van-collapse v-model="subItem.activeNames">
                    <van-collapse-item title="" name="1">
                      <template #title>
                        <div class="collapse-title">
                          <div>{{ $t('form.orderGiftVolume') }}：<span class="pcs-num" style="color: #808000;" v-if="subItem.specList">{{ subItem.specList.reduce((acc, curr) => acc + Number(curr.quantity), 0) }}</span> {{ $t('form.pcs') }}</div>
                        </div>
                      </template>
                      <div class="quantity-item custom-quantity-item" v-for="specItem in subItem.specList" :key="specItem.specId">
                        <div class="title van-ellipsis">{{ specItem.specName }}</div>
                        <div class="stepper-custom">
                          <div class="step-btn" @click="handleStep(-5, specItem, 'quantity')">-5</div>
                          <div class="step-btn" @click="handleStep(-1, specItem, 'quantity')">-</div>
                          <van-field class="step-value" v-model.number="specItem.quantity" type="digit" :border="false" />
                          <div class="step-btn" @click="handleStep(1, specItem, 'quantity')">+</div>
                          <div class="step-btn" @click="handleStep(5, specItem, 'quantity')">+5</div>
                        </div>
                      </div>
                    </van-collapse-item>
                  </van-collapse>
                </div>
              </div>
              <div class="add-more custom-add-more" @click="handleAdd('giveProductList', brandItem)">+ {{ $t('button.addMoreProductForGiving') }}</div>
            </div>
            <div class="form-item">
              <div class="label required">{{ $t('form.paymentType') }}</div>
              <XuSelect v-model="visitForm.po.paymentType" :dataOptions="globalData.payType" />
            </div>
            <div class="form-item">
              <div class="label required">
                <span>{{ $t('form.paymentStatus') }}</span>
              </div>
              <van-field class="custom-field custom-radio-field">
                <template #input>
                  <van-radio-group v-model="visitForm.po.paymentStatus" direction="horizontal">
                    <van-radio v-for="(subItem, subIndex) in paymentStatusList" :key="subIndex" :name="subItem.value">{{ subItem.label }}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </div>
            <div class="form-item">
              <div class="label required">
                <span>{{ $t('form.tax') }}</span>
              </div>
              <van-field class="custom-field custom-radio-field">
                <template #input>
                  <van-radio-group v-model="visitForm.po.taxType" direction="horizontal">
                    <van-radio v-for="(subItem, subIndex) in taxTypeList" :key="subIndex" :name="subItem.value">{{ subItem.label }}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </div>
            <div class="form-item">
              <div class="label square">
                <span>{{ $t('form.pOOrder') }}</span>
              </div>
              <van-uploader v-model="visitForm.imgMap.directPoOrder" :after-read="(files, detail) => afterRead(files, detail, 'directPoOrder')" />
            </div>
            <div class="form-item">
              <div class="label square">
                <span>{{ $t('form.receipt') }}</span>
              </div>
              <van-uploader v-model="visitForm.imgMap.directReceipt" :after-read="(files, detail) => afterRead(files, detail, 'directReceipt')" />
            </div>
            <div class="form-item">
              <div class="label square">
                <span>{{ $t('form.productCashCheque') }}</span>
              </div>
              <van-uploader v-model="visitForm.imgMap.directProductCashOrCheque" :after-read="(files, detail) => afterRead(files, detail, 'directProductCashOrCheque')" />
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item title="Sell-in from Distributor" name="2">
          <div class="form-item" v-for="(brandItem, brandIndex) in visitForm.reorderList" :key="brandIndex">
            <div class="label square">
              <span>{{ brandItem.projectName }}</span>
            </div>
            <div class="brand-item" v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex">
              <div class="product-status">
                <XuSelect v-model="subItem.productId" :dataOptions="filteredOptions.reorderList(brandIndex, subItem.productId, brandItem.projectId)" :placeholder="$t('tips.pleaseSelectProduct')" :fieldNames="{label: 'productName', value: 'id'}" />
                <img src="@/assets/images/event_del.png" alt="" class="del-img" @click="handleDel(brandItem, subIndex)">
              </div>
              <div class="product-listing">
                <div class="listing-product">
                  <div class="checkout-custom">
                    <div>{{ $t('form.totalSellIn') }}：<span class="total-pcs">{{ calculateNum(subItem.quantity, subItem.giveQuantity) }}</span> {{ $t('form.pcs') }}</div>
                  </div>
                  <div class="quantity-item">
                    <div class="title">{{ $t('form.quantitySoldPcs') }}</div>
                    <div class="stepper-custom">
                      <div class="step-btn" @click="handleStep(-5, subItem, 'quantity')">-5</div>
                      <div class="step-btn" @click="handleStep(-1, subItem, 'quantity')">-</div>
                      <van-field class="step-value" v-model.number="subItem.quantity" type="digit" :border="false" />
                      <div class="step-btn" @click="handleStep(1, subItem, 'quantity')">+</div>
                      <div class="step-btn" @click="handleStep(5, subItem, 'quantity')">+5</div>
                    </div>
                  </div>
                  <div class="quantity-item">
                    <div class="title">{{ $t('form.quantityGivenAwayPcs') }}</div>
                    <div class="stepper-custom">
                      <div class="step-btn" @click="handleStep(-5, subItem, 'giveQuantity')">-5</div>
                      <div class="step-btn" @click="handleStep(-1, subItem, 'giveQuantity')">-</div>
                      <van-field class="step-value" v-model.number="subItem.giveQuantity" type="digit" :border="false" />
                      <div class="step-btn" @click="handleStep(1, subItem, 'giveQuantity')">+</div>
                      <div class="step-btn" @click="handleStep(5, subItem, 'giveQuantity')">+5</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="add-more" @click="handleAdd('reorderList', brandItem)">+ {{ $t('button.addMoreProduct') }}</div>
            <template v-if="brandReorderSdMap[brandItem.projectId]">
              <div class="subset-form-item">
                <div class="label required">
                  <span>{{ $t('shared.distributor') }}</span>
                </div>
                <div class="select-field custom-field" @click="toSelectStoreSd('reorderList', brandItem)">
                  {{ brandItem.expandInfo.sdList.map(item => item.sdName).join(',') }}
                </div>
              </div>
              <div class="form-item">
                <div class="label">
                  <span>{{ $t('form.otherDistributor') }}</span>
                </div>
                <van-field v-model="brandItem.expandInfo.otherSd" placeholder="" :border="false" class="custom-field" />
              </div>
            </template>
          </div>
          <div class="form-item">
            <div class="label square">
              <span>{{ $t('form.pOOrder') }}</span>
            </div>
            <van-uploader v-model="visitForm.imgMap.poOrder" :after-read="(files, detail) => afterRead(files, detail, 'poOrder')" />
          </div>
          <div class="form-item">
            <div class="label square">
              <span>{{ $t('form.receipt') }}</span>
            </div>
            <van-uploader v-model="visitForm.imgMap.receipt" :after-read="(files, detail) => afterRead(files, detail, 'receipt')" />
          </div>
          <div class="form-item">
            <div class="label square">
              <span>{{ $t('form.productCashCheque') }}</span>
            </div>
            <van-uploader v-model="visitForm.imgMap.productCashOrCheque" :after-read="(files, detail) => afterRead(files, detail, 'productCashOrCheque')" />
          </div>
        </van-collapse-item>
        <van-collapse-item :title="$t('form.materialSampleDelivery')" name="3">
          <div class="form-item">
            <div class="label square">
              <span>{{ $t('form.sampleDelivery') }}</span>
            </div>
            <div class="sample-delivry">
              <div class="main-header">
                <div class="left-header">
                  <span>{{ $t('form.total') }} </span>
                  <span class="total-num">{{ sampleListTotal }} </span>
                  <span>{{ $t('form.pcs') }}</span>
                </div>
                <div class="sell-out-btn" @click="toSelectSample">+ {{ $t('button.select') }}</div>
              </div>
              <div class="promotion-item" v-for="subItem in sampleList" :key="subItem.productId">
                <img v-if="subItem.imgUrl" class="icon-img" :src="subItem.imgUrl" alt="">
                <img v-else class="icon-img" src="@/assets/images/icon_noimg.png" alt="">
                <div class="info-item">
                  <div class="product-info">
                    <span class="product-name txt-ellipsis">{{ subItem.projectName }}·{{ subItem.productName }}</span>
                    <!-- <van-icon v-if="subItem.isMain === 1" name="star" color="#e0bc38" /> -->
                  </div>
                  <div class="material-inventory">
                    <span class="inventory-num txt-ellipsis">{{ $t('form.inv') }}：{{ subItem.inventoryCount }}</span>
                  </div>
                </div>
                <div class="stepper-custom">
                  <div class="step-btn" @click="handleStep(-5, subItem, 'quantity', { checkInventory: true })">-5</div>
                  <div class="step-btn" @click="handleStep(-1, subItem, 'quantity', { checkInventory: true })">-</div>
                  <van-field class="step-value" v-model.number="subItem.quantity" type="digit" :border="false" @blur="handleQuantityInputBlur(subItem)" />
                  <div class="step-btn" @click="handleStep(1, subItem, 'quantity', { checkInventory: true })">+</div>
                  <div class="step-btn" @click="handleStep(5, subItem, 'quantity', { checkInventory: true })">+5</div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-item">
            <div class="label square">
              <span>{{ $t('form.materialDelivery') }}</span>
            </div>
            <div class="material-delivery">
            <div class="main-header">
              <div class="left-header">
                <span>{{ $t('form.total') }} </span>
                <span class="total-num">{{ materialListTotal }} </span>
                <span>{{ $t('form.pcs') }}</span>
              </div>
              <div class="sell-out-btn" @click="toSelectMaterial">+ {{ $t('button.select') }}</div>
            </div>
            <div class="promotion-item" v-for="subItem in materialList" :key="subItem.id">
              <img v-if="subItem.imgUrl" class="icon-img" :src="subItem.imgUrl" alt="">
              <img v-else class="icon-img" src="@/assets/images/icon_noimg.png" alt="">
              <div class="info-item">
                <div class="product-info">
                  <span class="product-name txt-ellipsis">{{ subItem.materielName }}</span>
                  <van-icon v-if="subItem.isMain === 1" name="star" color="#e0bc38" />
                </div>
                <div class="material-inventory">
                  <div class="product-name-item" v-if="subItem.materielType === 1">
                    <div class="project-name universal-name">{{ subItem.projectName }}</div>
                    <div class="inventory-num">{{ $t('form.inv') }}: {{ subItem.inventoryCount }}</div>
                  </div>
                  <div class="product-name-item" v-else>
                    <div class="project-name" v-for="proItem in subItem.productName.split(',')" :key="proItem">{{ proItem }}</div>
                    <div class="inventory-num">{{ $t('form.inv') }}: {{ subItem.inventoryCount }}</div>
                  </div>
                </div>
              </div>
              <div class="stepper-custom">
                <div class="step-btn" @click="handleStep(-5, subItem, 'quantity', { checkInventory: true })">-5</div>
                <div class="step-btn" @click="handleStep(-1, subItem, 'quantity', { checkInventory: true })">-</div>
                <van-field class="step-value" v-model.number="subItem.quantity" type="digit" :border="false" @blur="handleQuantityInputBlur(subItem)" />
                <div class="step-btn" @click="handleStep(1, subItem, 'quantity', { checkInventory: true })">+</div>
                <div class="step-btn" @click="handleStep(5, subItem, 'quantity', { checkInventory: true })">+5</div>
              </div>
            </div>
          </div>
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.materialSamplePhoto') }}</span>
            </div>
            <van-uploader v-model="visitForm.imgMap.deliveryMaterialProto" :after-read="(files, detail) => afterRead(files, detail, 'deliveryMaterialProto')" />
          </div>
        </van-collapse-item>
        <van-collapse-item :title="$t('shared.feedback')" name="4">
          <div class="form-item">
            <div class="label">
              <span></span>
            </div>
            <van-field v-model="visitForm.feedback" type="textarea" show-word-limit rows="3" placeholder="" class="custom-field field-textarea" />
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div class="visit-btn">
      <van-button class="submit-btn" @click="handleSubmit">{{ $t('button.submit') }}</van-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import { Toast, Dialog } from 'vant'
import { arsVisitAddOrUpdateApi, arsVisitInfoApi } from '@/api/visit'
import { calculateAdd } from '@/utils/math'
import { arsProjectAppQueryListApi } from '@/api/storeMaintain'
import { homeCurrentTimeApi } from '@/api/shared'
const copyVisitForm = {
  id: '',
  customerId: '',
  lng: '',
  lat: '',
  inputAddress: '',
  visitTime: '', // moment(new Date()).format('YYYY-MM-DD'),
  feedback: '',
  imgMap: {
    check: [],
    poOrder: [],
    directPoOrder: [],
    receipt: [],
    directReceipt: [],
    productCashOrCheque: [],
    directProductCashOrCheque: [],
    deliveryMaterialProto: []
  },
  po: {
    isDirect: false,
    // orderType: '',
    productList: [],
    giveProductList: [],
    paymentType: '',
    paymentStatus: '',
    taxType: ''
  },
  reorderList: []
}
export default {
  components: {
    XuSelect: () => import('@/components/XuSelect')
  },
  data () {
    return {
      activeNames: [],
      showCalendar: false,
      currentDate: new Date(),
      visitForm: {
        id: '',
        customerId: '',
        lng: '',
        lat: '',
        inputAddress: '',
        visitTime: '',
        feedback: '',
        imgMap: {
          check: [],
          poOrder: [],
          directPoOrder: [],
          receipt: [],
          directReceipt: [],
          productCashOrCheque: [],
          directProductCashOrCheque: [],
          deliveryMaterialProto: []
        },
        po: {
          isDirect: false,
          // orderType: '',
          productList: [],
          giveProductList: [],
          paymentType: '',
          paymentStatus: '',
          taxType: ''
        },
        reorderList: []
      },
      radioList: [
        { label: this.$t('shared.filter.yes'), value: true },
        { label: this.$t('shared.filter.no'), value: false }
      ],
      maxDate: new Date(),
      paymentStatusList: [
        { label: this.$t('form.paid'), value: 'Paid' },
        { label: this.$t('form.unpaid'), value: 'Unpaid' }
      ],
      taxTypeList: [
        { label: this.$t('form.taxInclusive'), value: 'Tax Inclusive' },
        { label: this.$t('form.taxExclusive'), value: 'Tax Exclusive' }
      ],
      sampleList: [],
      materialList: []
    }
  },
  activated () {
    if (this.isNavigatingToSelect) {
      const materialDelivery = JSON.parse(window.localStorage.getItem('materialDelivery'))
      if (materialDelivery) {
        this.materialList = materialDelivery
        window.localStorage.removeItem('materialDelivery')
      }
    } else if (this.isNavigateToSampleSelect) {
      const sampleDelivery = JSON.parse(window.localStorage.getItem('sampleDelivery'))
      if (sampleDelivery) {
        this.sampleList = sampleDelivery
        window.localStorage.removeItem('sampleDelivery')
      }
    } else if (this.isNavigateToSdSelect) {
      const sdStoreSelect = JSON.parse(window.localStorage.getItem('sdStoreSelect'))
      if (sdStoreSelect) {
        this.visitForm[sdStoreSelect.typeKey].find(subItem => {
          if (subItem.projectId === sdStoreSelect.brandId) {
            subItem.expandInfo.sdList = sdStoreSelect.typeValue
            return subItem
          }
        })
        window.localStorage.removeItem('sdStoreSelect')
      }
    } else {
      this.activeNames = []
      this.materialList = []
      this.sampleList = []
      this.visitForm = JSON.parse(JSON.stringify(copyVisitForm))
      const { visitId = '', customerId = '' } = this.$route.query
      this.visitForm.id = visitId
      this.visitForm.customerId = customerId
      this.echoData()
      this.initData()
    }
    this.isNavigatingToSelect = false
    this.isNavigateToSampleSelect = false
    this.isNavigateToSdSelect = false
  },
  beforeRouteLeave (to, from, next) {
    if (to.path === '/selectMaterial') {
      this.isNavigatingToSelect = true
    } else if (to.path === '/shared/selectSample') {
      this.isNavigateToSampleSelect = true
    } else if (to.path === '/shared/selectStoreSd') {
      this.isNavigateToSdSelect = true
    }
    next()
  },
  computed: {
    ...mapState({
      globalData: 'globalData',
      userInfo: 'myUserInfo'
    }),
    materialListTotal () {
      return this.materialList.reduce((acc, curr) => acc + Number(curr.quantity), 0)
    },
    sampleListTotal () {
      return this.sampleList.reduce((acc, curr) => acc + Number(curr.quantity), 0)
    },
    totalProductQuantity () {
      if (!this.visitForm.po || !this.visitForm.po.productList) {
        return 0
      }
      return this.visitForm.po.productList.reduce((total, product) => {
        if (!product.productList) {
          return total
        }
        const productTotal = product.productList.reduce((productSum, subProduct) => {
          if (!subProduct.specList) {
            return productSum
          }
          const specTotal = subProduct.specList.reduce((subTotal, spec) => {
            return subTotal + (Number(spec.quantity) || 0)
          }, 0)
          return productSum + specTotal
        }, 0)
        return total + productTotal
      }, 0)
    },
    totalGiveProductQuantity () {
      if (!this.visitForm.po || !this.visitForm.po.giveProductList) {
        return 0
      }
      return this.visitForm.po.giveProductList.reduce((total, product) => {
        if (!product.productList) {
          return total
        }
        const productTotal = product.productList.reduce((productSum, subProduct) => {
          if (!subProduct.specList) {
            return productSum
          }
          const specTotal = subProduct.specList.reduce((subTotal, spec) => {
            return subTotal + (Number(spec.quantity) || 0)
          }, 0)
          return productSum + specTotal
        }, 0)
        return total + productTotal
      }, 0)
    },
    filteredOptions () {
      const result = {
        productList: [],
        reorderList: [],
        giveProductList: []
      }
      if (!this.globalData.productList) return result

      // Helper function to get options excluding other selected IDs
      const getOptionsForList = (list, currentId = null, projectId = null) => {
        const selectedIds = list.map(item => item.productId).filter(id => id && id !== currentId)
        return this.globalData.productList.filter(item => {
          // If it's a shelfList, it must match the projectId
          if (projectId && item.projectId !== projectId) {
            return false
          }
          // Include if it's the current item's ID or if it's not selected by others
          return !selectedIds.includes(item.id)
        })
      }

      // We need to return a function that looks up the correct array so we can pass currentId
      return {
        productList: (brandIndex, currentId, projectId) => {
          const brandItem = this.visitForm.po.productList[brandIndex]
          if (!brandItem) return []
          return getOptionsForList(brandItem.productList, currentId, projectId)
        },
        giveProductList: (brandIndex, currentId, projectId) => {
          const brandItem = this.visitForm.po.giveProductList[brandIndex]
          if (!brandItem) return []
          return getOptionsForList(brandItem.productList, currentId, projectId)
        },
        reorderList: (brandIndex, currentId, projectId) => {
          const brandItem = this.visitForm.reorderList[brandIndex]
          if (!brandItem) return []
          return getOptionsForList(brandItem.productList, currentId, projectId)
        }
      }
    },
    brandReorderSdMap () {
      const map = {}
      if (!this.visitForm.reorderList) return map
      this.visitForm.reorderList.forEach(brandItem => {
        map[brandItem.projectId] = brandItem.productList.some(subItem => {
          return subItem.productId
        })
      })
      return map
    }
  },
  methods: {
    handelSelect (currentVal, params) {
      const findData = this.globalData.productList.find(subItem => {
        if (subItem.id === currentVal) {
          return subItem
        }
      })
      if (findData) {
        const newSpecList = JSON.parse(JSON.stringify(findData.specList))
        newSpecList.forEach(subItem => {
          subItem.quantity = ''
        })
        this.$set(params, 'specList', newSpecList)
      }
    },
    handleCalendar () {
      // if (this.visitForm.id) return
      // this.showCalendar = true
    },
    handleAdd (type, params = {}) {
      const formeKey = params.productList
      const filterProduct = this.globalData.productList.filter(item => item.projectId === params.projectId)
      if (formeKey.length >= filterProduct.length) {
        Toast(this.$t('tips.noMoreProducts'))
        return
      }
      if (type === 'reorderList') {
        params.productList.push({
          productId: '',
          giveQuantity: '',
          quantity: ''
        })
      } else if (['giveProductList', 'productList'].includes(type)) {
        params.productList.push({ productId: '', specList: [], activeNames: ['1'] })
      }
    },
    handleDel (params, index) {
      Dialog.confirm({
        message: this.$t('tips.messageNine'),
        confirmButtonText: this.$t('button.confirm'),
        cancelButtonText: this.$t('button.cancel'),
        confirmButtonColor: '#c4200b'
      })
        .then(() => {
          params.productList.splice(index, 1)
        })
        .catch(() => {
          // on cancel
        })
    },
    initData () {
      if (!this.visitForm.id) {
        const currentTimeLoc =
          JSON.parse(window.localStorage.getItem('currentTimeLoc')) || {}
        this.visitForm.lat = currentTimeLoc.lat
        this.visitForm.lng = currentTimeLoc.lng
        if (!currentTimeLoc.lat) return
        // 根据经纬度获取位置
        this.$nextTick(() => {
          new google.maps.Geocoder().geocode(
            {
              location: new google.maps.LatLng(currentTimeLoc.lat, currentTimeLoc.lng)
            },
            (results, status) => {
              // 这里处理结果和上面一模一样
              if (status === google.maps.GeocoderStatus.OK) {
                this.visitForm.inputAddress = results[0].formatted_address
              } else {
                console.log('：error ' + status)
              }
            }
          )
        })
      }
    },
    onConfirmDate (date) {
      this.visitForm.visitTime = moment(date).format('YYYY-MM-DD')
      this.showCalendar = false
    },
    getFilteredOptions (listKey, currentId) {
      if (!this.globalData.productList) return []
      let selectedIds = []
      if (['giveProductList', 'productList'].includes(listKey)) {
        selectedIds = this.visitForm.po[listKey].map(item => item.productId).filter(id => id && id !== currentId)
      } else {
        selectedIds = this.visitForm[listKey].map(item => item.productId).filter(id => id && id !== currentId)
      }
      return this.globalData.productList.filter(item => !selectedIds.includes(item.id))
    },
    handleSubmit () {
      if (!this.visitForm.visitTime) {
        Toast(this.$t('tips.messageThirtyThree'))
        return
      }
      if (this.handleChecked()) {
        return
      }
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      const { imgMap } = this.visitForm
      const data = {
        ...this.visitForm,
        imgMap: {
          check: imgMap.check.map(subItem => subItem.url).join(','),
          poOrder: imgMap.poOrder.map(subItem => subItem.url).join(','),
          directPoOrder: imgMap.directPoOrder.map(subItem => subItem.url).join(','),
          receipt: imgMap.receipt.map(subItem => subItem.url).join(','),
          directReceipt: imgMap.directReceipt.map(subItem => subItem.url).join(','),
          productCashOrCheque: imgMap.productCashOrCheque.map(subItem => subItem.url).join(','),
          directProductCashOrCheque: imgMap.directProductCashOrCheque.map(subItem => subItem.url).join(','),
          deliveryMaterialProto: imgMap.deliveryMaterialProto.map(subItem => subItem.url).join(',')
        },
        putMaterielList: this.materialList.map(subItem => { return { id: subItem.id, quantity: subItem.quantity } }),
        protoList: this.sampleList.map(subItem => { return { productId: subItem.productId, quantity: subItem.quantity } }),
        visitType: '2'
      }
      arsVisitAddOrUpdateApi(data).then(res => {
        Toast.clear()
        this.$router.go(-1)
      })
    },
    async echoData () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      if (this.visitForm.id) {
        const res = await arsVisitInfoApi(this.visitForm.id)
        Toast.clear()
        const { reorderList, po, imgMap, putMaterielList, protoList } = res.data
        po.productList.forEach(brandItem => {
          brandItem.productList.forEach(subItem => {
            subItem.activeNames = ['1']
          })
        })
        po.giveProductList.forEach(brandItem => {
          brandItem.productList.forEach(subItem => {
            subItem.activeNames = ['1']
          })
        })
        reorderList.forEach(brandItem => {
          brandItem.expandInfo.sdList = brandItem.expandInfo.sdList || []
          brandItem.expandInfo.otherSd = brandItem.expandInfo.otherSd || ''
        })
        Object.keys(this.visitForm).forEach(subItem => {
          if (subItem === 'imgMap') {
            this.visitForm[subItem].check = this.imgFormat(imgMap.check)
            this.visitForm[subItem].poOrder = this.imgFormat(imgMap.poOrder)
            this.visitForm[subItem].directPoOrder = this.imgFormat(imgMap.directPoOrder)
            this.visitForm[subItem].receipt = this.imgFormat(imgMap.receipt)
            this.visitForm[subItem].directReceipt = this.imgFormat(imgMap.directReceipt)
            this.visitForm[subItem].productCashOrCheque = this.imgFormat(imgMap.productCashOrCheque)
            this.visitForm[subItem].directProductCashOrCheque = this.imgFormat(imgMap.directProductCashOrCheque)
            this.visitForm[subItem].deliveryMaterialProto = this.imgFormat(imgMap.deliveryMaterialProto)
          } else {
            this.visitForm[subItem] = res.data[subItem]
          }
        })
        putMaterielList.forEach(subItem => {
          subItem.isChoose = true
          subItem.originalInventoryCount = Number(subItem.inventoryCount) || 0
        })
        protoList.forEach(subItem => {
          subItem.isChoose = true
          subItem.originalInventoryCount = Number(subItem.inventoryCount) || 0
        })
        this.materialList = putMaterielList || []
        this.sampleList = protoList
      } else {
        Toast.clear()
        arsProjectAppQueryListApi().then(res => {
          res.data.forEach(subItem => {
            this.visitForm.po.productList.push({ projectId: subItem.id, projectName: subItem.projectName, productList: [] })
            this.visitForm.po.giveProductList.push({ projectId: subItem.id, projectName: subItem.projectName, productList: [] })
            this.visitForm.reorderList.push({ projectId: subItem.id, projectName: subItem.projectName, productList: [], expandInfo: { sdList: [], otherSd: '' } })
          })
        })
        homeCurrentTimeApi().then(res => {
          this.visitForm.visitTime = moment(res.data).format('YYYY-MM-DD')
        })
      }
    },
    imgFormat (arr) {
      let newArr = []
      if (arr.length > 0) {
        newArr = arr.split(',').map(subItem => {
          return { url: subItem }
        })
        return newArr
      } else {
        return []
      }
    },
    getlocation (lat, lng, toAddress) {},
    handleStep (delta, params, typeKey, obj = {}) {
      if (obj.checkInventory) {
        let newQuantity = (Number(params[typeKey]) || 0) + delta
        if (newQuantity < 0) {
          newQuantity = 0
        }
        const newInventory = params.originalInventoryCount - newQuantity
        this.$set(params, typeKey, newQuantity)
        this.$set(params, 'inventoryCount', newInventory)
      } else {
        let newQuantity = params[typeKey] ? parseFloat(params[typeKey]) : 0
        newQuantity += delta
        if (newQuantity <= 0) newQuantity = 0
        this.$set(params, typeKey, newQuantity)
      }
    },
    handleQuantityInputBlur (item) {
      let newQuantity = Number(item.quantity) || 0
      if (newQuantity < 0) {
        newQuantity = 0
        this.$set(item, 'quantity', 0)
      }
      const newInventory = item.originalInventoryCount - newQuantity
      this.$set(item, 'inventoryCount', newInventory)
    },
    quantityFormatter (value) {
      return value.replace(/^0+/, '')
    },
    handleChecked () {
      let isFlag = false
      const { imgMap, po, reorderList } = this.visitForm
      const isShowDirect = this.checkPer(['admin', 'app:reorder:direct']) && po.isDirect
      if (imgMap.check.length <= 0) {
        Toast(this.$t('tips.checkInPhotoIsRequired'))
        isFlag = true
      }

      if (isFlag) {
        return isFlag
      }
      if (isShowDirect) {
        po.productList.find(brandItem => {
          brandItem.productList.find(subItem => {
            if (!subItem.productId) {
              Toast(this.$t('tips.sellInFromAcmefogInIsRequired'))
              isFlag = true
              return subItem
            }
          })
          if (isFlag) {
            return brandItem
          }
        })
        if (isFlag) {
          return isFlag
        }
        po.giveProductList.find(brandItem => {
          brandItem.productList.find(subItem => {
            if (!subItem.productId) {
              Toast(this.$t('tips.sellInFromAcmefogInIsRequired'))
              isFlag = true
              return subItem
            }
          })
          if (isFlag) {
            return brandItem
          }
        })
        if (isFlag) {
          return isFlag
        }
      }
      if (isFlag) {
        return isFlag
      }
      let isSales = true
      let tipsSingle = ''
      reorderList.find(brandItem => {
        tipsSingle = this.$t('tips.messageThirtyFour', { projectName: brandItem.projectName })
        if (brandItem.productList.length > 0) {
          isSales = false
        }
        brandItem.productList.find(subItem => {
          if (!subItem.productId || (subItem.productId && this.calculateNum(subItem.quantity, subItem.giveQuantity) <= 0)) {
            isFlag = true
            Toast(!subItem.productId ? `${this.$t('form.sellInFromDistributor')} ${this.$t('tips.isRequired')}` : this.$t('tips.productIsRequired'))
            return subItem
          }
          if (this.checkPer(['admin', 'app:sd:visitInput']) && subItem.productId && brandItem.expandInfo.sdList.length <= 0 && !brandItem.expandInfo.otherSd) {
            isFlag = true
            Toast(tipsSingle)
            return subItem
          }
        })
        if (isFlag) {
          return brandItem
        }
      })
      if (isFlag) {
        return isFlag
      }
      // 增加限制：reorder整体产品销量（含直售/渠道下单）需要大于1 才能提交本次订单
      if (isSales && (!isShowDirect || (this.totalProductQuantity <= 0 && this.totalGiveProductQuantity <= 0))) {
        Toast(this.$t('tips.pleaseInputTheSales'))
        isFlag = true
      }

      if (isFlag) {
        return isFlag
      }

      if (isShowDirect) {
        // 'orderType',
        const checkList = [
          { label: this.$t('form.paymentType'), value: 'paymentType' },
          { label: this.$t('form.paymentStatus'), value: 'paymentStatus' },
          { label: this.$t('form.tax'), value: 'taxType' }
        ]
        checkList.find(subItem => {
          if (['', null].includes(po[subItem.value])) {
            Toast(`${subItem.label} ${this.$t('tips.isRequired')}`)
            isFlag = true
            return subItem
          }
        })
      }

      return isFlag
    },
    afterRead (files, detail, key) {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      this.$uploadImg(files)
        .then((res) => {
          Toast.clear()
          this.$set(this.visitForm.imgMap[key], detail.index, {
            url: res.url
          })
        })
        .catch((err) => {
          console.log('err', err)
          Toast.clear()
          this.visitForm.imgMap[key].splice(detail.index, 1)
          Toast(this.$t('tips.uploadFailed'))
        })
    },
    calculateNum (num1, num2) {
      return calculateAdd(num1, num2)
    },
    toSelectMaterial () {
      if (this.materialList.length > 0) {
        window.localStorage.setItem('materialDelivery', JSON.stringify(this.materialList))
      }
      this.$router.push('/selectMaterial?pageType=reorder')
    },
    toSelectSample () {
      if (this.sampleList.length > 0) {
        window.localStorage.setItem('sampleDelivery', JSON.stringify(this.sampleList))
      }
      this.$router.push('/shared/selectSample?pageType=expandVisit')
    },
    toSelectStoreSd (currKey, params) {
      window.localStorage.setItem('sdStoreSelect', JSON.stringify({ typeKey: currKey, typeValue: params.expandInfo.sdList || [], brandId: params.projectId }))
      this.$router.push('/shared/selectStoreSd')
    }
  }
}
</script>

<style lang="less" scoped>
.store-visit {
  // display: flex;
  // flex-direction: column;
  // height: 100%;
  .visit-form-content {
    // flex: 1;
    // overflow-y: auto;
    padding-bottom: 50px;
    /deep/.van-collapse {
      .van-collapse-item {
        background-color: #fff;
        .van-collapse-item__title {
          background-color: #e8effc;
          font-weight: bold;
          padding: 5px 10px;
          margin-bottom: 2px;
          .van-cell__title {
            font-weight: bold;
            > span {
              font-size: 14px;
            }
          }
        }
        .van-collapse-item__content {
          padding: 0px 10px;
          padding-top: 10px;
        }
      }
      &::after {
        border: none;
      }
    }
    .form-item,
    .subset-form-item {
      margin-bottom: 20px;
      .label {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #333;
        margin-bottom: 8px;
        // 添加必填标记样式
        &.required {
          position: relative;
          padding-left: 12px; // 为星号预留空间
          &::before {
            content: '*';
            color: #ff4444;
            position: absolute;
            left: 0;
            top: 0;
            font-size: 14px;
            line-height: 1;
          }
        }
        &.square {
          font-weight: bold;
          &::before {
            content: '';
            width: 8px;
            height: 8px;
            background-color: #307bff;
            // position: absolute;
            // left: 0;
            // top: 0;
            transform: rotate(45deg);
            margin-right: 5px;
          }
        }
        .label-icon {
          width: 16px;
          height: 16px;
          margin-left: 3px;
        }
      }
      .custom-label {
        &.square {
          &::before {
            background-color: #808000;
          }
        }
      }
      .label-bottom {
        padding-bottom: 8px;
        border-bottom: 1px solid #ebedf0;
      }
      .custom-field {
        padding: 5px 10px;
        background: #fff;
        border: 1px solid #b9cbed;
        border-radius: 4px;
        font-size: 12px;
        &::placeholder {
          color: #999;
        }
      }
      .custom-radio-field {
        padding: 0;
        font-size: 12px;
        border: none;
      }
      .product-quantity {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        .chiledren-label {
          margin-left: 16px;
          margin-right: 5px;
          font-size: 12px;
          color: #333;
        }
        .custom-xu-select {
          width: 166px;
        }
        .half-field {
          flex: 1;
        }
      }
      .del-img {
        width: 20px;
        height: 20px;
        margin-left: 5px;
      }
      .brand-item {
        font-size: 12px;
        margin-bottom: 10px;
      }
      .product-status {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .product-listing {
        padding: 10px;
        margin-top: 10px;
        background-color: #f7f7f7;
        border-radius: 10px;
        .listing-item {
          padding-bottom: 5px;
          border-bottom: 1px solid #ebedf0;
          .listing-label {
            margin-bottom: 5px;
            font-size: 12px;
            color: #333;
          }
          /deep/.van-cell {
            width: auto;
          }
          .custom-radio-field {
            background-color: #f7f7f7;
          }
        }
        .listing-product {
          .checkout-custom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 6px 0;
            font-size: 12px;
            color: #7f7f7f;
            font-weight: bold;
            .total-pcs {
              color: #307bff;
              font-weight: bold;
            }
          }
          .quantity-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 12px;
            margin-bottom: 5px;
            .title {
              width: 186px;
              &::before {
                content: '#';
                width: 8px;
                height: 8px;
                color: #307bff;
                margin-right: 5px;
              }
            }
          }
          /deep/.van-checkbox {
            .van-checkbox__label {
              margin-left: 3px;
            }
            .van-checkbox__icon {
              height: auto;
            }
          }
        }
      }
      .is-Direct {
        .quantity-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 12px;
          margin-bottom: 5px;
          .title {
            width: 186px;
            &::before {
              content: '#';
              width: 8px;
              height: 8px;
              color: #307bff;
              margin-right: 5px;
            }
          }
        }
        .custom-quantity-item {
          .title {
            &::before {
              color: #808000;
            }
          }
        }
        /deep/.van-collapse {
          .van-collapse-item__title {
            padding: 0;
            font-size: 12px;
            background-color: #f7f7f7;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            margin-bottom: 0;
          }
          .van-collapse-item__title--expanded::after {
            display: none;
          }
          .van-collapse-item__content {
            padding: 10px;
            font-size: 12px;
            background-color: #f7f7f7;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
          }
          .van-cell__right-icon {
            right: 10px;
            top: 2px;
          }
        }
        /deep/.van-hairline--top-bottom::after {
          display: none;
        }
      }
      .stepper-custom {
        display: flex;
        align-items: center;
        border: 1px solid #b9cbed;
        border-radius: 4px;
        overflow: hidden;
        .step-btn {
          width: 28px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #fff;
          color: #333333;
          cursor: pointer;
          border-right: 1px solid #b9cbed;;
          font-size: 12px;
          &:last-child {
            border-right: none;
          }
          &:active {
            background-color: #f2f3f5;
          }
        }
        .step-value {
          width: 32px;
          height: 24px;
          padding: 0;
          background-color: #fff;
          border-right: 1px solid #b9cbed;
          border-radius: 0;
          /deep/ .van-field__control {
            text-align: center;
            height: 24px;
            line-height: 24px;
            color: #323233;
            font-size: 12px;
          }
        }
      }
      /deep/.van-uploader {
        .van-uploader__upload {
          width: 60px;
          height: 60px;
        }
        .van-uploader__preview-image {
          width: 60px;
          height: 60px;
        }
      }
      .select-field {
        display: flex;
        align-items: center;
        min-height: 36px;
        color: #333;
      }
    }
    .subset-form-item {
      margin-top: 20px;
    }
    .product-title {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      color: #333;
      border-bottom: 1px solid #e8effc;
      margin-bottom: 10px;
      font-size: 13px;
      .left-desc {
        flex: 1;
        font-weight: bold;
      }
      &.square {
        &::before {
          content: '';
          width: 8px;
          height: 8px;
          background-color: #307bff;
          // position: absolute;
          // left: 0;
          // top: 0;
          transform: rotate(45deg);
          margin-right: 5px;
        }
      }
    }
    .sub-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 5px 0;
      border-bottom: 1px solid #e8effc;
      font-size: 12px;
      margin-bottom: 10px;
      .total-right {
        color: #333;
      }
      .top-title {
        display: flex;
        font-weight: bold;
        color: #000;
        font-size: 12px;
        .ell-icon {
          margin-top: 2px;
          width: 11px;
          height: 11px;
          margin-right: 5px;
        }
      }
    }
    .uploader-customer {
      display: flex;
      justify-content: space-between;
      padding-left: 10px;
      .label {
        align-self: flex-start;
      }
    }
    .sell-in-quantity {
      margin-bottom: 43px;
    }
    .form-time-item {
      display: flex;
      align-items: center;
      padding: 0 10px;
      margin-top: 10px;
      .label {
        margin-right: 10px;
        margin-bottom: 0;
      }
      .custom-field {
        flex: 1;
      }
    }
    .add-more {
      display: inline-block;
      padding: 5px;
      font-size: 12px;
      color: #307bff;
      border: 1px solid #307bff;
      background-color: #e4eefc;
      border-radius: 6px;
    }
    .custom-add-more {
      color: #808000;
      border: 1px solid #808000;
      background-color: #ECECD4;
    }
    .psi-section {
      margin: 10px;
      margin-top: 0;
      padding: 50px 60px;
      text-align: center;
      background-color: #f7f7f7;
      border-radius: 10px;
      color: #333;
      font-size: 12px;
    }
    .sample-delivry,
    .material-delivery {
      color: #333;
      margin-bottom: 10px;
      .main-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 10px;
        border-top: 1px solid #e8effc;
        border-bottom: 2px solid #e8effc;
        font-size: 12px;
        .total-num {
          font-size: 14px;
          font-weight: bold;
          color: #307bff;
        }
        &:first-child {
          border-top: none;
        }
      }
      .sell-out-btn {
        height: 23px;
        line-height: 23px;
        padding: 0px 3px;
        background-color: #e8effc;
        border-radius: 5px;
        font-size: 11px;
        border: 1px solid #307bff;
        color: #307bff;
      }
      .promotion-item {
        display: flex;
        align-items: center;
        padding: 10px 6px;
        border-bottom: 1px solid #b9cbed;
        font-size: 12px;
        .icon-img {
          width: 40px;
          height: 40px;
          margin-right: 10px;
          object-fit: contain;
        }
        .info-item {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          min-height: 40px;
          .product-info {
            display: flex;
            align-items: center;
          }
          .product-name {
            max-width: 136px;
            font-size: 13px;
          }
          .material-inventory {
            display: flex;
            align-items: center;
            .product-name-item {
              display: flex;
              align-items: center;
              flex-wrap: wrap;
            }
            .project-name {
              padding: 1px 3px;
              border: 1px solid #307bff;
              color: #307bff;
              margin-right: 3px;
              margin-bottom: 3px;
              font-size: 10px;
            }
            .universal-name {
              border: 1px solid #34b032;
              color: #34b032;
            }
            .inventory-num {
              flex: 1;
            }
          }
        }
        .stepper-custom {
          display: flex;
          align-items: center;
          border: 1px solid #b9cbed;
          border-radius: 4px;
          overflow: hidden;
          .step-btn {
            width: 28px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #fff;
            color: #323233;
            cursor: pointer;
            border-right: 1px solid #b9cbed;;
            font-size: 12px;
            &:last-child {
              border-right: none;
            }
            &:active {
              background-color: #f2f3f5;
            }
          }
          .step-value {
            width: 32px;
            height: 24px;
            padding: 0;
            background-color: #fff;
            border-right: 1px solid #b9cbed;
            border-radius: 0;
            /deep/ .van-field__control {
              text-align: center;
              height: 24px;
              line-height: 24px;
              color: #323233;
              font-size: 12px;
            }
          }
        }
      }
    }
  }
  .visit-btn {
    position: fixed;
    width: 100%;
    bottom: 0;
    .submit-btn {
      width: 100%;
      background-color: #307bff;
      color: #fff;
      font-weight: bold;
    }
  }
  .pcs-num {
    color: #307bff;
    font-weight: bold;
  }
}
</style>
